import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { ContextStore } from "../../App";

const SolarCalculatorFunctionalities = () => {
  const [appliances, setAppliances] = useState({});
  const [usage, setUsage] = useState({});
  const [location, setLocation] = useState("high");
  const [totalConsumption, setTotalConsumption] = useState(0);
  const [dailyConsumption, setdailyConsumption] = useState(0);
  const { formData } = useContext(ContextStore);
  const [recommendation, setRecommendation] = useState(null);

  const { firstName, lastName, email, phone } = formData;

  // **************************** handleAddAppliancesField ****************************

  const handleAddAppliancesField = (item) => {
    setAppliances((prevState) => ({
      ...prevState,
      [item.id]: [
        ...(prevState[item.id] || []),
        { wattage: "", quantity: "", hours: "" },
      ],
    }));
  };

  // **************************** handleRemoveInputField ****************************

  // Function to remove a specific input field
  const handleRemoveInputField = (itemId, index) => {
    setAppliances((prevState) => ({
      ...prevState,
      [itemId]: prevState[itemId].filter((_, i) => i !== index),
    }));
  };
  // **************************** handleInputChange ****************************

  const handleInputChange = (itemId, index, field, value) => {
    if (["quantity", "hours"].includes(field) && (isNaN(value) || value < 0)) {
      alert(`${field} must be positive number`);
    }
    if (field === "location") {
      setLocation(value);
      return;
    }
    setAppliances((prevState) => {
      const updatedEssentialData = { ...prevState };

      // Ensure itemId exists in state
      if (!updatedEssentialData[itemId]) {
        updatedEssentialData[itemId] = [];
      }

      // Create a copy of the array at itemId
      const updatedArray = [...updatedEssentialData[itemId]];

      // Ensure the object at index exists
      if (!updatedArray[index]) {
        updatedArray[index] = { wattage: "", quantity: "", hours: "" };
      } else {
        updatedArray[index] = { ...updatedArray[index] };
      }

      // Update the field value
      updatedArray[index][field] = value;

      // Update state with the new array
      updatedEssentialData[itemId] = updatedArray;

      return updatedEssentialData;
    });
  };

  // **************** Solar Recommendation Calculation ****************

  const AVG_PANEL_WATTAGE = 400;
  const COST_PER_PANEL = 350; // dollars per panel including installation
  const SOLAR_SUBSIDY_RATE = 0.3; // 30% federal tax credit

  const DAILY_SUN_HOURS = {
    high: 6.5, // high sun exposure (e.g., Rajasthan, Gujarat, Tamil Nadu)
    medium: 5.5, // medium sun exposure (e.g., Maharashtra, Karnataka, Andhra Pradesh)
    low: 4.5, // low sun exposure (e.g., Kerala, Northeast India, Himachal Pradesh)
  };
  const calculateSolarRecommendation = async (e, appliances) => {
    e.preventDefault();
    let totalConsumption = 0;
    let dailyConsumption = 0;

    for (const itemId in appliances) {
      const applianceGroup = appliances[itemId];

      for (const appliance of applianceGroup) {
        const { wattage, quantity, hours } = appliance;

        const wattageValue = parseInt(wattage?.replace("W", "")) || 0;
        const quantityValue = parseInt(quantity) || 1;
        const hoursValue = parseInt(hours) || 0;

        const perDayConsumption =
          (wattageValue * hoursValue * quantityValue) / 1000;
        dailyConsumption += perDayConsumption;
        totalConsumption += perDayConsumption * 30;
      }
    }

    setTotalConsumption(totalConsumption);

    if (!totalConsumption || isNaN(totalConsumption) || totalConsumption <= 0) {
      return;
    }

    // Solar recommendation calculation
    const requiredSystemSizeKw = dailyConsumption / DAILY_SUN_HOURS[location];
    const numberOfPanels = Math.ceil(
      (requiredSystemSizeKw * 1000) / AVG_PANEL_WATTAGE
    );
    const actualSystemSizeKw = (numberOfPanels * AVG_PANEL_WATTAGE) / 1000;

    const estimatedCost = numberOfPanels * COST_PER_PANEL;
    const afterSubsidy = estimatedCost * (1 - SOLAR_SUBSIDY_RATE);

    const dailyProduction = actualSystemSizeKw * DAILY_SUN_HOURS[location];
    const monthlyProduction = dailyProduction * 30;
    const annualProduction = dailyProduction * 365;

    const electricityRate = 8; // average $0.15 per kWh
    const annualSavings = annualProduction * electricityRate;
    const paybackYears = afterSubsidy / annualSavings;

    setRecommendation({
      numberOfPanels,
      systemSizeKw: actualSystemSizeKw.toFixed(2),
      estimatedCost: estimatedCost.toFixed(2),
      afterSubsidy: afterSubsidy.toFixed(2),
      monthlyProduction: monthlyProduction.toFixed(2),
      annualProduction: annualProduction.toFixed(2),
      paybackYears: paybackYears.toFixed(1),
    });
  };
  const SiteSurveyInputs = [
    {
      id: 1,
      name: "firstName",
      label: "First Name",
      placeholder: "Enter your first name",
      type: "text",
      value: firstName,
    },
    {
      id: 2,
      name: "lastName",
      label: "Last Name",
      placeholder: "Enter your last name",
      type: "text",
      value: lastName,
    },
    {
      id: 3,
      name: "email",
      label: "Email",
      placeholder: "Enter your email",
      type: "email",
      value: email,
    },
    {
      id: 4,
      name: "phone",
      label: "Mobile Number",
      placeholder: "Enter your mobile number",
      type: "tel",
      value: phone,
    },
  ];
  return {
    handleRemoveInputField,
    appliances,
    usage,
    setUsage,
    setAppliances,
    calculateSolarRecommendation,
    totalConsumption,
    SiteSurveyInputs,
    location,
    handleAddAppliancesField,
    handleInputChange,
    recommendation,
    SiteSurveyInputs,
  };
};

export default SolarCalculatorFunctionalities;
